import { useAggregatedDataV2 } from "~/hooks/useAggregatedDataV2.ts";
import userViewGuard from "~/hooks/useViewPermssionsCheck";
import { useAllPendingInvoices } from "~/modules/billing/api/pendingInvoice/pendingInvoiceQueries.ts";
import PendingInvoicesIndexView from "~/modules/billing/components/PendingInvoicesIndexView";
import { useAllUsers } from "~/modules/user/api/user/userQueries.ts";
import { PermissionNames } from "~/types/entityNames.ts";

const PendingInvoicesIndexPage = () => {
	const guard = userViewGuard([PermissionNames.CanManageInvoices, PermissionNames.CanViewInvoices]);
	if (guard) return guard;

	const { data, options } = useAggregatedDataV2({
		allPendingInvoices: useAllPendingInvoices(),
	});

	// prefetch all non-pending invoices and users to ensure they are available when needed
	useAllUsers();

	const { allPendingInvoices } = data;

	return <PendingInvoicesIndexView isLoading={options.isLoading}
									 pendingInvoicesData={allPendingInvoices} />;
};

export default PendingInvoicesIndexPage;